// import $ from 'jquery';

// uncomment mode development
// require('./modules/jquery.min');
// require('./modules/royal_preloader.min');

require('./modules/jquery.magnific-popup.min');
// require('./modules/jquery.isotope.min');
require('./modules/owl.carousel.min');
require('./modules/easypiechart.min');
require('./modules/scripts');
require('./modules/header-mobile');

require('./../../node_modules/jquery-validation/dist/jquery.validate');
require('./../../node_modules/jquery-validation/dist/additional-methods');

require('./modules/contactform');

import './../sass/main.scss';

window.jQuery = window.$ = jQuery;

//(function($) { "use strict";
  //Preloader
  /*Royal_Preloader.config({
    mode           : 'logo',
    logo           : 'images/logo.svg',
    logo_size      : [160, 75],
    showProgress   : true,
    showPercentage : true,
    text_colour: '#000000',
    background:  '#ffffff'
  });*/
//})(jQuery);
